import { useEffect, useState } from 'react';
import {usePrevious} from "../../../../../misc/helperHooks";

/**
 * Keeps the last visible viewType for inactive cards during exit transition.
 *
 * @param {boolean} isActive - whether the card is currently active
 * @param {number} globalViewType - viewType from Redux (or another global state)
 * @param {number} sectionViewType - default viewType defined for the section
 */
export function useLatchedViewType(isActive, globalViewType, sectionViewType) {
  const [latched, setLatched] = useState(sectionViewType);
  const prevIsActive = usePrevious(isActive);

  useEffect(() => {
    // Card just became inactive — freeze the viewType
    if (prevIsActive && !isActive) {
      setLatched(globalViewType);
    }

    // Optional: when reactivating, reset to section default
    if (!prevIsActive && isActive) {
      // Uncomment if you want a reset on re-enter:
      // setLatched(sectionViewType);
    }
  }, [isActive, prevIsActive, globalViewType, sectionViewType]);

  // Active → live Redux value, Inactive → frozen
  return isActive ? globalViewType : latched;
}
